'use strict';

require('jquery-validation');

var $ = require('jquery');

require('../vendor.js');
require('../plugins.js');

// structures
var backToTop = require('../structure/back-to-top.js');
var betaMessage	= require('../structure/beta-message.js');
var modelSwitcher = require('../structure/model-switcher.js');
var primaryNav = require('../structure/primary-nav.js');
var siteNav = require('../structure/site-nav.js');
var siteSearch = require('../structure/site-search.js');

// ui
var anchors = require('../ui/anchors.js');
var images = require('../ui/images.js');
var sticky = require('../ui/sticky.js');

// watchers
var heightWatcher = require('../watchers/height-watcher.js');
var scrollWatcher = require('../watchers/scroll-watcher.js');
var screenSizeWatcher = require('../watchers/screen-size-watcher.js');

// utils
var debugHelper = require('../utils/debug-helper.js');
var config = require('../utils/config.js');
var logger = require('../utils/logger.js');
var analytics = require('../utils/analytics.js');
var foundationWrapper = require('../utils/foundation-wrapper.js');

function initConfig() {
	if (typeof config === 'undefined') {
		window.alert('The parkersConfig JSON object must be defined before parkers.js is loaded.');
	} else {
		logger.info('Parkers config', config);
	}
}

function startWatchers() {
	heightWatcher.start();
	scrollWatcher.start();
	screenSizeWatcher.start();
}

function loadStructure() {
	siteNav.init();
	primaryNav.init();
	siteSearch.init();
	backToTop.init();
	betaMessage.init();
	modelSwitcher.init();
}

function loadUI() {
	anchors.init();
	images.init();
	sticky.init();
}

function loadContent() {
	analytics.initClickTracking();
}

function initialiseBasePage() {
	
	window.parkers_dfp = {
		init: function () {
			logger.warn('parkers_dfp - no implementation present.');
		}
	};

	initConfig();
	startWatchers();
	$(document).foundation();
	loadStructure();
	loadUI();
	loadContent();	
	debugHelper.init();
	foundationWrapper.init();

	logger.debug('Initialising page - after ' + logger.secondsSincePageStart());	
}

module.exports = {
	initBasePage: initialiseBasePage,
	init: initialiseBasePage,
	utils: {
		analytics: analytics
	}
};